import { render, staticRenderFns } from "./CdcSummary.vue?vue&type=template&id=9ce8de36&scoped=true&"
import script from "./CdcSummary.vue?vue&type=script&lang=js&"
export * from "./CdcSummary.vue?vue&type=script&lang=js&"
import style0 from "./CdcSummary.vue?vue&type=style&index=0&id=9ce8de36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce8de36",
  null
  
)

export default component.exports